module.exports = __webpack_public_path__ + "img/feedback_caution.4ca796ce.svg";